import {
  GoogleAuthProvider,
  FacebookAuthProvider,
  signInWithPopup,
} from "firebase/auth";

import { auth } from "../firebase";

const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

const facebookProvider =
  new FacebookAuthProvider();

export async function signInWithGoogle() {
  try {
    const result = await signInWithPopup(
      auth,
      googleProvider
    );

    return {
      success: true,
      user: result.user,
    };

  } catch (error) {
    console.error("Google Auth Error:", error);

    return {
      success: false,
      error,
    };
  }
}

export async function signInWithFacebook() {
  try {
    const result = await signInWithPopup(
      auth,
      facebookProvider
    );

    return {
      success: true,
      user: result.user,
    };

  } catch (error) {
  console.error(
    "Facebook Auth Error:",
    error
  );

  if (
    error.code ===
    "auth/account-exists-with-different-credential"
  ) {
    return {
      success: false,
      error: {
        message:
          "An account already exists with this email. Please login using your original sign-in method.",
      },
    };
  }

  return {
    success: false,
    error,
  };
}
}